import { heroFeature } from "@/mocks/homeData";

export default function HeroFeature() {
  return (
    <section id="top" className="px-4 pb-12 pt-10 md:px-10 md:pb-16 md:pt-16">
      <div className="grid grid-cols-1 items-stretch gap-10 lg:grid-cols-12 lg:gap-0">
        <div className="animate-fade-up flex flex-col justify-center lg:col-span-7 lg:pr-12">
          <div className="flex items-center gap-3 font-label text-[11px] uppercase tracking-[0.3em] text-primary-600">
            <span className="h-px w-8 bg-primary-500" />
            {heroFeature.kicker}
          </div>

          <h2 className="mt-5 font-heading text-3xl font-black leading-[1.25] text-foreground-950 md:text-5xl md:leading-[1.22]">
            {heroFeature.title}
          </h2>

          <p className="mt-5 max-w-xl text-sm leading-loose text-foreground-700 md:mt-6 md:text-base">
            {heroFeature.summary}
          </p>

          <div className="mt-6 flex flex-wrap items-center gap-2">
            {heroFeature.tags.map((tag) => (
              <span
                key={tag}
                className="inline-flex items-center whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1.5 text-xs text-secondary-900"
              >
                {tag}
              </span>
            ))}
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-3 font-label text-xs text-foreground-500">
            <span>撰文 · {heroFeature.author}</span>
            <span>{heroFeature.date}</span>
            <span>阅读约 {heroFeature.readingTime}</span>
          </div>
        </div>

        <div className="animate-fade-up animate-delay-2 flex flex-col lg:col-span-5 lg:border-l lg:border-background-300 lg:pl-12">
          <div className="h-[320px] w-full overflow-hidden rounded-lg bg-background-100 md:h-[440px]">
            <img
              src="https://readdy.ai/api/search-image?query=Editorial%20magazine%20cover%20style%20abstract%20collage%20with%20torn%20paper%20textures%2C%20muted%20crimson%20and%20warm%20cream%20tones%2C%20dramatic%20side%20lighting%2C%20vintage%20print%20grain%2C%20elegant%20negative%20space%2C%20high%20fashion%20editorial%20mood%2C%20warm%20neutral%20background%2C%20no%20text%2C%20refined%20artistic%20atmosphere&width=900&height=1100&seq=heiliaozhan-hero-01&orientation=portrait"
              alt="黑料总站本期封面视觉 · 今日热点话题聚合"
              title="黑料总站 今日热点 话题聚合"
              className="h-full w-full object-cover object-top"
            />
          </div>

          <div className="mt-6 grid grid-cols-3 border-t border-background-300 pt-5">
            {heroFeature.stats.map((stat, idx) => (
              <div
                key={stat.label}
                className={idx !== 0 ? "border-l border-background-300 pl-4" : ""}
              >
                <div className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
                  {stat.value}
                </div>
                <div className="mt-1 font-label text-[11px] tracking-wider text-foreground-500">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}